import { EventInput } from "@fullcalendar/core";
import dayjs from "dayjs";
import type { Dispatch } from "react";
import { REDUCER_ACTION_TYPES } from "./constants";
import type { CalendarAction } from "./reducer";

export interface CalendarViewRange {
  start: string;
  end: string;
}

export interface CalendarQuery {
  sportCourtId: string[];
  status?: string;
  customerId?: string;
  [key: string]: string | string[] | undefined;
}

export interface CalendarState {
  events: EventInput[];
  currentViewRange: CalendarViewRange;
  query: CalendarQuery;
  refresh: number;
}

export const getCalendarInicialState = (): CalendarState => {
  return {
    events: [],
    currentViewRange: {
      start: dayjs().format("YYYY-MM-DD"),
      end: dayjs().format("YYYY-MM-DD"),
    },

    query: {
      sportCourtId: [],
    },
    refresh: 0,
  };
};

export const changeCurrentViewRange = (
  dispatch: Dispatch<CalendarAction>,
  currentViewRange: CalendarViewRange
) => {
  dispatch({
    type: REDUCER_ACTION_TYPES.CHANGE_DATE_RANGE,
    payload: {
      currentViewRange,
    },
  });
};

export const updateSchedulesOnCalendar = (
  dispatch: Dispatch<CalendarAction>,
  events: EventInput[]
) => {
  dispatch({
    type: REDUCER_ACTION_TYPES.UPDATE_CALENDAR_SCHEDULES,
    payload: {
      events,
    },
  });
};
export const changeFilterSportCourt = (
  dispatch: Dispatch<CalendarAction>,
  sportCourtId: string[]
) => {
  dispatch({
    type: REDUCER_ACTION_TYPES.CHANGE_FILTER_SPORT_COURT,
    payload: {
      sportCourtId,
    },
  });
};

export const changeFilterStatus = (
  dispatch: Dispatch<CalendarAction>,
  status: string
) => {
  dispatch({
    type: REDUCER_ACTION_TYPES.CHANGE_FILTER_STATUS,
    payload: {
      status,
    },
  });
};

export const changeFilterCustomer = (
  dispatch: Dispatch<CalendarAction>,
  customerId: string
) => {
  dispatch({
    type: REDUCER_ACTION_TYPES.CHANGE_FILTER_CUSTOMER,
    payload: {
      customerId,
    },
  });
};

export const refreshCalendar = (dispatch: Dispatch<CalendarAction>) => {
  dispatch({
    type: REDUCER_ACTION_TYPES.REFRESH_CALENDAR,
  });
};
